import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceAdvisorService {

  constructor(private ws: PostmethodService) { }

  serviceAdvisorCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "serviceAdvisorMaster");
  }
}
